import { render, staticRenderFns } from "./StandardField.vue?vue&type=template&id=2e722ba8&scoped=true&"
import script from "./StandardField.vue?vue&type=script&lang=js&"
export * from "./StandardField.vue?vue&type=script&lang=js&"
import style0 from "./StandardField.vue?vue&type=style&index=0&id=2e722ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e722ba8",
  null
  
)

export default component.exports